var stateData = {
    items: [],
    total_cost: 0
};

export default stateData;